import React from "react"

const ResumeContext = React.createContext({
    jobTitle: "",
    updateJobTitle: () => { },
    name: "",
    updateName: () => { },
    email: "",
    updateEmail: () => { },
    phone: "",
    updatePhone: () => { },
    resumeImage: "",
    updateResumeImage: () => {},
    resumeImageObject: {},
    updateResumeImageObject: () => {},
    skillNames: [],
    updateSkillNames: () => { },
    degree: "",
    updateDegree: () => { },
    stream: "",
    updateStream: () => { },
    institute: "",
    updateInstitute: () => { },
    year: "",
    updateYear: () => { },
    password: "",
    updatePassword: () => { },
    confirmPassword: "",
    updateConfirmPassword: () => { },

    projecttitle: "",
    updateProjecttitle: () => { },

    client: "",
    updateClient: () => { },

    role: "",
    updateRole: () => { },

    experience: "",
    updateExperience: () => { },
    country: "",
    updateCountry: () => { },
    countryLabel: "United States",
    updateCountryLabel: () => { },
    state: "",
    updateState: () => { },
    RegionName:"",
    updateRegionName: () => { },
    stateLabel: {name:"",shortRegion:""},
    updateStateLabel: () => { },
    visaType: "",
    updateVisaType: () => { },
    visaTypeLabel: "",
    updateVisaTypeLabel: () => { },
    jobType: [],
    updateJobType: () => { },
    jobTypeLabel: [],
    updateJobTypeLabel: () => { },
    city: "",
    updateCity: () => { },
    cityLabel: "",
    updateCityLabel: () => { },


    start: "",
    updateStartdate: () => { },

    enddate: "",
    updateEnddate: () => { },

    description: "",
    updateDescription: () => { },


    //certificate: [{ certName: "", certYear: "" }],
    certificate: [{ certName: "", certYear: "" }],
    updateCertificate: () => { },
    education: [{ university: "", yearofpassing: "", degree: "" }],
    updateEducation: () => { },

    project: [{
        projectTitle: "", country: "", countryname: "", state: "", statename: "", city: "",cityname: "",
        responsibilities: "", description: "", startdate: "", company: "", enddate: "", role: "" , checked : false , descCount : 0 , resCount:0
    }],
    updateProject: () => { },
    aiSkills: [],
    updateAISkills: () => { },
    summary: "",
    updateSummary: () => { },
    skills: [{
        category: "",
        skills: [],
        category_id : ""
      },],
    updateSkills: () => { },
    
    website: "",
    updateWebsite: () => { },

    linkedIn: "",
    updateLinkedIn: () => { },

    gitHub : "",
    updateGitHub: () => { },

    hackerRank : "",
    updateHackerRank: () => { },

    leetCode : "",
    updateLeetCode: () => { },

    portfolio: "",
    updatePortfolio: () => { },

    resumetemplate: "0",
    updateResumetemplate: () => { },
    userId: "",
    updateUserId: () => { },

    finish: false,
    updateFinish: () => { },
    finishOne: false,
    updateFinishOne: () => { },
    stepperValue: 0,
    updateStepperValue: () => { },
    certificateLogo: "",
    updateCertificateLogo: () => {},
    affiliations:"",
    updateAffiliations : () => {},
    statesList: [],
    getStates: () => { },
}

)
export default ResumeContext;